import React, { useEffect, useState, useRef } from 'react';
import { Link } from "gatsby";
import Layout from "../layouts/tc";
import eduhklibLogo from '../images/eduhklib-logo.jpeg';
import eieuLogo from '../images/eieu-logo.png';
import aboutImage from '../images/about.png';
import eventLogo from '../images/event-logo.jpg';
import eventStorytelling from '../images/event-storytelling.jpg';
import eventSocialMedia from '../images/event-socialmedia.jpg';
import eventDream from '../images/event-dream.jpg';
import eventKol from '../images/event-kol.jpg';
import eventDesignThinking from '../images/event-designthinking.jpg';
import eventStartup from '../images/event-startup.jpg';
import bestLogoDesignAward from "../images/best-logo-design-award-work.jpg";
import peoplesChoiceAward from "../images/peoples-choice-award-work.png";

export default function Home(props) {
  return (
    <Layout location={props.location} isOnMain={true}>
      <div id="about" className="lg:py-20 py-10">
        <div className="container mx-auto px-4 lg:px-0">
          <div className="lg:flex">
            <div className="lg:flex-1 lg:pr-10">
              <img
                src={aboutImage}
                alt=""
                className="lg:float-right mt-5 lg:h-48 lg:block hidden"
              />
              <h5 className="text-orange-600">#about</h5>
              <h3 className="lg:text-3xl text-xl font-bold">EI Fiesta</h3>
              <p className="leading-loose mt-3">
                由香港教育大學圖書館企業及創新教育組主辦、大學教育資助委員會資助的EI
                Fiesta將於2022年3月至6月舉行。EI Fiesta
                旨在為所有教大同學提供開闊視野的機會，通過不同學習活動培育同學的創業和創新思維及能力，並將知識應用於日常生活及將來的工作。
              </p>

              <div className="mt-5 leading-loose">
                <h4 className="lg:text-xl text-lg font-bold">預期成果</h4>
                <p className="leading-loose mt-1">教大學生參與活動後能夠</p>
                <ul className="list-disc ml-5">
                  <li>展現21世紀需要的創業知識與技能；</li>
                  <li>
                    培養創意思維、解決問題能力和溝通技巧，以識別、定義和應對與其未來專業或日常生活相關的挑戰；
                  </li>
                  <li>
                    展示創業和創新能力，以發掘及把握機會、沉實應對挑戰，及創造新想法或方法；和
                  </li>
                  <li>
                    意識到持續學習和自我提升的重要性，並能夠規劃和管理自己的學習，以追求自我目標。
                  </li>
                </ul>
              </div>

              <div className="mt-5 leading-loose">
                <h4 className="lg:text-xl text-lg font-bold">參與及認可</h4>
                <p className="leading-loose mt-1">我們鼓勵同學參與所有活動:</p>
                <ul className="list-disc ml-5">
                  <li>
                    同學參加的活動時數（活動標誌設計及比賽除外），將被記錄在其「經驗學習及成就報告表（ELAT）」
                  </li>
                  <li>凡參與1至2項活動的同學，將獲發出席證書乙張</li>
                  <li>
                    凡參與3至4項活動的同學，將獲發修業證書乙張及精美紀念品乙份
                  </li>
                  <li>
                    凡參與5至6項活動的同學，將獲發結業證書乙張及精美紀念品乙份
                  </li>
                </ul>
              </div>

              <div className="mt-5 leading-loose">
                <h4 className="lg:text-xl text-lg font-bold">資助</h4>
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 mt-2">
                  <a
                    href="https://www.ugc.edu.hk/eng/ugc/index.html"
                    target="_blank"
                    rel="noreferrer"
                    class="block px-2 py-1 text-center font-medium"
                  >
                    大學教育資助委員會
                    <br />
                    University Grants Committee
                  </a>
                </div>
              </div>

              <div className="mt-5 leading-loose">
                <h4 className="lg:text-xl text-lg font-bold">主辦單位</h4>
                <div className="grid grid-cols-2 lg:grid-cols-6 gap-4 mt-2">
                  <a
                    href="https://www.lib.eduhk.hk"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={eduhklibLogo}
                      className="h-12 object-contain"
                      alt="EdUHK Library"
                    />
                  </a>
                  <a
                    href="https://eieu.lib.eduhk.hk"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={eieuLogo}
                      className="h-12 object-contain"
                      alt="EIEU"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="activities" className="lg:py-20 py-10 bg-gray-50 relative">
        <div className="container mx-auto px-4 lg:px-0">
          <div className="lg:flex mt-5">
            <Link to="/tc/activities/event-logo-design">
              <img
                src={eventLogo}
                className="lg:w-64 lg:h-auto w-3/4 h-32 mx-auto object-cover rounded"
              />
            </Link>
            <div className="lg:flex-1 lg:ml-10 lg:mt-0 mt-3">
              <h3 className="lg:text-xl text-lg font-bold">
                <Link
                  to="/tc/activities/event-logo-design"
                  className="hover:text-gray-700"
                >
                  活動標誌設計及演説比賽
                </Link>
              </h3>
              <ul className="lg:flex mt-3">
                <li>
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      ></path>
                    </svg>
                    提交作品截止日期: 4月20日下午5時正
                  </p>
                </li>
                <li className="lg:ml-4">
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                      ></path>
                    </svg>
                    名額: 不適用
                  </p>
                </li>
              </ul>

              <p className="mt-5">
                同學可以個人或團隊形式提交活動標誌設計及演說短片，以爭奪以下三個獎項...{" "}
                <Link
                  to="/tc/activities/event-logo-design"
                  className="text-blue-600 hover:text-blue-700 underline"
                >
                  更多
                </Link>
              </p>
            </div>
            <div className="lg:ml-10 lg:mt-0 mt-5 flex items-center">
              <a
                href="https://eduhk.au1.qualtrics.com/jfe/form/SV_8BTdHu8eQI5TY8K"
                className="cta inline-block"
                target="_blank"
                rel="noreferrer"
              >
                報名
              </a>
            </div>
          </div>

          <div className="lg:flex mt-8 border-t-2 border-gray-200 pt-8">
            <Link to="/tc/activities/workshop-effective-presentation-storytelling-skills">
              <img
                src={eventStorytelling}
                className="lg:w-64 lg:h-auto w-3/4 h-32 mx-auto object-cover rounded"
              />
            </Link>
            <div className="lg:flex-1 lg:ml-10 lg:mt-0 mt-3">
              <h3 className="lg:text-xl text-lg font-bold">
                <Link
                  to="/tc/activities/workshop-effective-presentation-storytelling-skills"
                  className="hover:text-gray-700"
                >
                  有效演講及說故事技巧工作坊
                </Link>
              </h3>
              <ul className="lg:flex mt-3">
                <li>
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      ></path>
                    </svg>
                    4月11日下午3時至5時
                  </p>
                </li>
                <li className="lg:ml-4">
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      ></path>
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      ></path>
                    </svg>
                    以Zoom線上形式進行
                  </p>
                </li>
                <li className="lg:ml-4">
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                      ></path>
                    </svg>
                    名額: 50
                  </p>
                </li>
              </ul>

              <p className="mt-5">
                同學將學習如何以說故事形式生動地進行演講，並從開場到結尾與觀眾保持連繫...{" "}
                <Link
                  to="/tc/activities/workshop-effective-presentation-storytelling-skills"
                  className="text-blue-600 hover:text-blue-700 underline"
                >
                  更多
                </Link>
              </p>
            </div>
            <div className="lg:ml-10 lg:flex lg:flex-col lg:items-end lg:justify-center lg:mt-0 mt-5">
              <a
                href="https://eduhk.au1.qualtrics.com/jfe/form/SV_0wiudOzAT7dhYBo"
                className="cta inline-block"
                target="_blank"
                rel="noreferrer"
              >
                報名
              </a>
              <p className="text-sm mt-3 italic font-bold">* 4月7日前報名</p>
              <p className="text-sm italic font-bold">* 名額有限，先到先得</p>
            </div>
          </div>

          <div className="lg:flex mt-8 border-t-2 border-gray-200 pt-8">
            <Link to="/tc/activities/tips-pomato-effective-social-media-strategy">
              <img
                src={eventSocialMedia}
                className="lg:w-64 lg:h-auto w-3/4 h-32 mx-auto object-cover rounded"
              />
            </Link>
            <div className="lg:flex-1 lg:ml-10 lg:mt-0 mt-3">
              <h3 className="lg:text-xl text-lg font-bold">
                <Link
                  to="/tc/activities/tips-pomato-effective-social-media-strategy"
                  className="hover:text-gray-700"
                >
                  「小薯茄」社交媒體策略工作坊
                </Link>
              </h3>
              <ul className="lg:flex mt-3">
                <li>
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      ></path>
                    </svg>
                    4月20日下午2時半至4時半
                  </p>
                </li>
                <li className="lg:ml-4">
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      ></path>
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      ></path>
                    </svg>
                    以Zoom線上形式進行
                  </p>
                </li>
                <li className="lg:ml-4">
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                      ></path>
                    </svg>
                    名額: 180
                  </p>
                </li>
              </ul>

              <p className="mt-5">
                同學將會認識社交媒體營銷的基本概念，了解幕後的準備工作，及從「小薯茄」的成功之道...{" "}
                <Link
                  to="/tc/activities/tips-pomato-effective-social-media-strategy"
                  className="text-blue-600 hover:text-blue-700 underline"
                >
                  更多
                </Link>
              </p>
            </div>
            <div className="lg:ml-10 lg:flex lg:flex-col lg:items-end lg:justify-center lg:mt-0 mt-5">
              <a
                href="https://eduhk.au1.qualtrics.com/jfe/form/SV_0wiudOzAT7dhYBo"
                className="cta inline-block"
                target="_blank"
                rel="noreferrer"
              >
                報名
              </a>
              <p className="text-sm mt-3 italic font-bold">* 4月18日前報名</p>
              <p className="text-sm italic font-bold">* 名額有限，先到先得</p>
            </div>
          </div>

          <div className="lg:flex mt-8 border-t-2 border-gray-200 pt-8">
            <Link to="/tc/activities/dream-dreams-full-time-job-entrepreneur-impact-students-dream">
              <img
                src={eventDream}
                className="lg:w-64 lg:h-auto w-3/4 h-32 mx-auto object-cover rounded"
              />
            </Link>
            <div className="lg:flex-1 lg:ml-10 lg:mt-0 mt-3">
              <h3 className="lg:text-xl text-lg font-bold">
                <Link
                  to="/tc/activities/dream-dreams-full-time-job-entrepreneur-impact-students-dream"
                  className="hover:text-gray-700"
                >
                  從全職工作到成為啟發學生追夢的企業家
                </Link>
              </h3>
              <ul className="lg:flex mt-3">
                <li>
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      ></path>
                    </svg>
                    5月3日下午4時至5時
                  </p>
                </li>
                <li className="lg:ml-4">
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      ></path>
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      ></path>
                    </svg>
                    以Zoom線上形式進行
                  </p>
                </li>
                <li className="lg:ml-4">
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                      ></path>
                    </svg>
                    名額: 90
                  </p>
                </li>
              </ul>

              <p className="mt-5">
                嘉賓講者將分享他的企業經歷，為何他由前美資銀行副總裁及著名填詞人，毅然轉行走入夢想之路，開辦社企...{" "}
                <Link
                  to="/tc/activities/dream-dreams-full-time-job-entrepreneur-impact-students-dream"
                  className="text-blue-600 hover:text-blue-700 underline"
                >
                  更多
                </Link>
              </p>
            </div>
            <div className="lg:ml-10 lg:flex lg:flex-col lg:items-end lg:justify-center lg:mt-0 mt-5">
              <a
                href="https://eduhk.au1.qualtrics.com/jfe/form/SV_0wiudOzAT7dhYBo"
                className="cta inline-block"
                target="_blank"
                rel="noreferrer"
              >
                報名
              </a>
              <p className="text-sm mt-3 italic font-bold">* 4月28日前報名</p>
              <p className="text-sm italic font-bold">* 名額有限，先到先得</p>
            </div>
          </div>

          <div className="lg:flex mt-8 border-t-2 border-gray-200 pt-8">
            <Link to="/tc/activities/kol-video-production-workshop">
              <img
                src={eventKol}
                className="lg:w-64 lg:h-auto w-3/4 h-32 mx-auto object-cover rounded"
              />
            </Link>
            <div className="lg:flex-1 lg:ml-10 lg:mt-0 mt-3">
              <h3 className="lg:text-xl text-lg font-bold">
                <Link
                  to="/tc/activities/kol-video-production-workshop"
                  className="hover:text-gray-700"
                >
                  「關鍵意見領袖」短片製作工作坊
                </Link>
              </h3>
              <ul className="lg:flex mt-3">
                <li>
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      ></path>
                    </svg>
                    4月7日及4月14日下午2時至5時
                  </p>
                </li>
                <li className="lg:ml-4">
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      ></path>
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      ></path>
                    </svg>
                    以Zoom線上形式進行
                  </p>
                </li>
                <li className="lg:ml-4">
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                      ></path>
                    </svg>
                    名額: 30
                  </p>
                </li>
              </ul>

              <p className="mt-5">
                同學將學習如何製作短片，學習將構思寫成情節，使用軟件製作2分鐘短片，並明白建立個人品牌的重點...{" "}
                <Link
                  to="/tc/activities/kol-video-production-workshop"
                  className="text-blue-600 hover:text-blue-700 underline"
                >
                  更多
                </Link>
              </p>
            </div>
            <div className="lg:ml-10 lg:flex lg:flex-col lg:items-end lg:justify-center lg:mt-0 mt-5">
              <a
                href="https://eduhk.au1.qualtrics.com/jfe/form/SV_0wiudOzAT7dhYBo"
                className="cta inline-block"
                target="_blank"
                rel="noreferrer"
              >
                報名
              </a>
              <p className="text-sm mt-3 italic font-bold">* 4月5日前報名</p>
              <p className="text-sm italic font-bold">* 名額有限，先到先得</p>
            </div>
          </div>

          <div className="lg:flex mt-8 border-t-2 border-gray-200 pt-8">
            <Link to="/tc/activities/design-thinking-workshop-human-centered-approach-innovation">
              <img
                src={eventDesignThinking}
                className="lg:w-64 lg:h-auto w-3/4 h-32 mx-auto object-cover rounded"
              />
            </Link>
            <div className="lg:flex-1 lg:ml-10 lg:mt-0 mt-3">
              <h3 className="lg:text-xl text-lg font-bold">
                <Link
                  to="/tc/activities/design-thinking-workshop-human-centered-approach-innovation"
                  className="hover:text-gray-700"
                >
                  設計思維工作坊:從人本到創新
                </Link>
              </h3>
              <ul className="lg:flex mt-3">
                <li>
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      ></path>
                    </svg>
                    5月30日下午2時至5時半
                  </p>
                </li>
                <li className="lg:ml-4">
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      ></path>
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      ></path>
                    </svg>
                    以Zoom線上形式進行
                  </p>
                </li>
                <li className="lg:ml-4">
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                      ></path>
                    </svg>
                    名額: 40
                  </p>
                </li>
              </ul>

              <p className="mt-5">
                同學將會學習及應用設計思維，透過具體練習學習以人本創新方法去創造新價值...{" "}
                <Link
                  to="/tc/activities/design-thinking-workshop-human-centered-approach-innovation"
                  className="text-blue-600 hover:text-blue-700 underline"
                >
                  更多
                </Link>
              </p>
            </div>
            <div className="lg:ml-10 lg:flex lg:flex-col lg:items-end lg:justify-center lg:mt-0 mt-5">
              <a
                href="https://eduhk.au1.qualtrics.com/jfe/form/SV_0wiudOzAT7dhYBo"
                className="cta inline-block"
                target="_blank"
                rel="noreferrer"
              >
                報名
              </a>
              <p className="text-sm mt-3 italic font-bold">* 5月25日前報名</p>
              <p className="text-sm italic font-bold">* 名額有限，先到先得</p>
            </div>
          </div>

          <div className="lg:flex mt-8 border-t-2 border-gray-200 pt-8">
            <Link to="/tc/activities/dialogue-startup-representatives">
              <img
                src={eventStartup}
                className="lg:w-64 lg:h-auto w-3/4 h-32 mx-auto object-cover rounded"
              />
            </Link>
            <div className="lg:flex-1 lg:ml-10 lg:mt-0 mt-3">
              <h3 className="lg:text-xl text-lg font-bold">
                <Link
                  to="/tc/activities/dialogue-startup-representatives"
                  className="hover:text-gray-700"
                >
                  與初創企業家對談
                </Link>
              </h3>
              <ul className="lg:flex mt-3">
                <li>
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      ></path>
                    </svg>
                    5月31日下午2時至3時半及下午4時至5時
                  </p>
                </li>
                <li className="lg:ml-4">
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      ></path>
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      ></path>
                    </svg>
                    以Zoom線上形式進行
                  </p>
                </li>
                <li className="lg:ml-4">
                  <p className="text-gray-600">
                    <svg
                      class="w-6 h-6 inline-block mr-1"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                      ></path>
                    </svg>
                    名額: 40
                  </p>
                </li>
              </ul>

              <p className="mt-5">
                同學將與初創企業家對話，以了解成立初創過程可能遇到的困難及他們應對的方法...{" "}
                <Link
                  to="/tc/activities/dialogue-startup-representatives"
                  className="text-blue-600 hover:text-blue-700 underline"
                >
                  更多
                </Link>
              </p>
            </div>
            <div className="lg:ml-10 lg:flex lg:flex-col lg:items-end lg:justify-center lg:mt-0 mt-5">
              <a
                href="https://eduhk.au1.qualtrics.com/jfe/form/SV_0wiudOzAT7dhYBo"
                className="cta inline-block"
                target="_blank"
                rel="noreferrer"
              >
                報名
              </a>
              <p className="text-sm mt-3 italic font-bold">* 5月26日前報名</p>
              <p className="text-sm italic font-bold">* 名額有限，先到先得</p>
            </div>
          </div>
        </div>
      </div>

      <div id="awards" className="lg:py-20 py-10">
        <div className="container mx-auto px-4 lg:px-0">
          <h5 className="text-orange-600">#awards</h5>
          <h3 className="lg:text-3xl text-xl font-bold">獎項</h3>

          <div className="mt-5">
            <h4 className="lg:text-xl text-lg font-bold">活動標誌設計及比賽</h4>
            <table class="w-full bg-orange-50 table-auto my-3">
              <thead>
                <tr>
                  <th
                    width="25%"
                    className="border border-black px-2 py-2 text-left"
                  >
                    獎項
                  </th>
                  <th className="border border-black px-2 py-2 text-left">
                    得獎名單
                  </th>
                  <th
                    width="37%"
                    className="border border-black px-2 py-2 text-left"
                  >
                    評審委員
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="border border-black px-2 py-2">
                    最佳活動標誌設計獎
                  </td>
                  <td class="border border-black px-2 py-2">
                    <img
                      src={bestLogoDesignAward}
                      alt=""
                      className="w-72 mx-auto"
                    />
                    <p className="mt-2 font-bold">Wong Sum Yuet</p>
                    <p>
                      Year 3, Bachelor of Arts (Honours) in Creative Arts and
                      Culture and BEd (Honours) (Visual Arts)
                    </p>
                  </td>
                  <td class="border border-black px-2 py-2" rowspan="2">
                    <ul className="list-disc ml-5">
                      <li>大學圖書館館長鄭保瑛博士</li>
                      <li>文化與創意藝術學系副教授洪強博士</li>
                      <li>課程與教學學系的高級講師甄沛豪博士</li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td class="border border-black px-2 py-2">最佳演說大獎</td>
                  <td class="border border-black px-2 py-2">
                    <p className="font-bold">Wong Sum Yuet</p>
                    <p>
                      Year 3, Bachelor of Arts (Honours) in Creative Arts and
                      Culture and BEd (Honours) (Visual Arts)
                    </p>
                  </td>
                </tr>
                <tr>
                  <td class="border border-black px-2 py-2">大眾選擇大獎</td>
                  <td class="border border-black px-2 py-2">
                    <img
                      src={peoplesChoiceAward}
                      alt=""
                      className="w-72 mx-auto"
                    />
                    <p className="mt-2 font-bold">Wong Tsz Ching</p>
                    <p>
                      Year 3, Bachelor of Education (Honours) (Early Childhood
                      Education) in Leadership and Special Needs
                    </p>
                    <p className="mt-3 font-bold">Cheng Chi Pang</p>
                    <p>
                      Year 3, Bachelor of Education (Honours) (Early Childhood
                      Education) in Leadership and Special Needs
                    </p>
                  </td>
                  <td class="border border-black px-2 py-2">不適用</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mt-10">
            <h4 className="lg:text-xl text-lg font-bold">
              「關鍵意見領袖」短片製作工作坊
            </h4>
            <table class="w-full bg-orange-50 table-auto my-3">
              <thead>
                <tr>
                  <th
                    width="25%"
                    className="border border-black px-2 py-2 text-left"
                  >
                    獎項
                  </th>
                  <th className="border border-black px-2 py-2 text-left">
                    得獎名單
                  </th>
                  <th
                    width="37%"
                    className="border border-black px-2 py-2 text-left"
                  >
                    評審委員
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="border border-black px-2 py-2">最佳短片大獎</td>
                  <td class="border border-black px-2 py-2">
                    <p className="font-bold">Lin Qixin</p>
                    <p>
                      Master of Arts in Teaching Chinese as an International
                      Language
                    </p>
                    <p className="mt-3">
                      請
                      <a
                        href="https://www.instagram.com/p/CdK7xjvglAM/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 hover:text-blue-700 underline"
                      >
                        按此
                      </a>
                      以觀看短片。
                    </p>
                  </td>
                  <td class="border border-black px-2 py-2">不適用</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
};
